import React, { useState } from "react";
import PropTypes from "prop-types";
import { CaretDown, CaretRight, Info } from "phosphor-react";
import ReactTooltip from "react-tooltip";
import "./index.scss";

const StackAccordion = ({ title, fields, totalArea, cost, originalCost }) => {
  const convertedCost = cost / 100;
  const convertedOriginalCost = (originalCost ?? 0) / 100;
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="stack-accordion">
      <div
        className="stack-accordion-item"
        onClick={() => setIsActive(!isActive)}
        aria-hidden
      >
        <div>
          {isActive ? <CaretDown size={20} /> : <CaretRight size={24} />}
        </div>
        <div className="stack-accordion-title">
          <div className="title">{title} fields</div>
          <div className="sub-title">
            <p className="hectare">{totalArea} hectares</p>
            <div className="price">
              <div className="price-wrapper">
                <p className="actual-price">
                  {parseFloat(convertedCost).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })}{" "}
                </p>
                {originalCost && (
                  <>
                    <ReactTooltip className="tooltip" effect="solid" />
                    <p className="old-price">
                      <Info
                        size={16}
                        weight="fill"
                        data-tip="Subscriber discount"
                      />
                      {parseFloat(convertedOriginalCost).toLocaleString(
                        "en-US",
                        {
                          style: "currency",
                          currency: "USD",
                        }
                      )}
                    </p>{" "}
                  </>
                )}
              </div>
              <p>per field</p>
            </div>
          </div>
        </div>
      </div>
      <div className="content-wrapper">
        {isActive &&
          fields?.map((field) => (
            <div className="accordion-content">
              <div className="group-content">
                <div className="text">{field?.properties?.field_name}</div>
              </div>
              <div className="group-content">
                <div className="label">
                  {field?.properties?.field_crop_type}
                </div>
                <div className="text">{field?.properties?.area} hectares</div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

StackAccordion.propTypes = {
  title: PropTypes.string.isRequired,
  fields: PropTypes.string.isRequired,
  totalArea: PropTypes.string.isRequired,
  cost: PropTypes.string.isRequired,
  originalCost: PropTypes.string.isRequired,
};
export default StackAccordion;
